/**
 * Storezone — Skeleton
 * Animated placeholder for loading states.
 */

import './Skeleton.css'

interface SkeletonProps {
  width?: string | number
  height?: string | number
  radius?: string
  className?: string
  style?: React.CSSProperties
}

export function Skeleton({
  width,
  height = '1em',
  radius,
  className = '',
  style,
}: SkeletonProps) {
  return (
    <span
      className={`sz-skeleton ${className}`}
      style={{
        width: width !== undefined ? (typeof width === 'number' ? `${width}px` : width) : undefined,
        height: typeof height === 'number' ? `${height}px` : height,
        borderRadius: radius,
        ...style,
      }}
      aria-hidden="true"
    />
  )
}

/** A full skeleton line block for text placeholders */
export function SkeletonText({ lines = 3 }: { lines?: number }) {
  return (
    <div className="sz-skeleton-text">
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton
          key={i}
          width={i === lines - 1 ? '60%' : '100%'}
          height={14}
        />
      ))}
    </div>
  )
}
